//全运会 full
import PlatfromCSMeetNationalGamesFull from '@containers/platfrom_compreSportsMeet/nationalGames_NSG.vue'

export default {
  PlatfromCSMeetNationalGamesFull,
}
